/**
 * @generated SignedSource<<3d12cec30e3d5cf979b3b70b53aeaa36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementMetadata_announcement$data = {
  readonly announcer: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
  };
  readonly canPin: {
    readonly value: boolean;
  };
  readonly canUnpin: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly lastEditedAt: ISO8601DateTimeString | null;
  readonly link: {
    readonly item: {
      readonly id?: string;
    } | null;
  } | null;
  readonly message: UnknownJSON | null;
  readonly pinned: boolean;
  readonly publishedAt: ISO8601DateTimeString | null;
  readonly space: {
    readonly modules: ReadonlyArray<{
      readonly canCreateAnnouncement?: {
        readonly value: boolean;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ItemMenu_node" | "PinOption_node">;
  readonly " $fragmentType": "AnnouncementMetadata_announcement";
};
export type AnnouncementMetadata_announcement$key = {
  readonly " $data"?: AnnouncementMetadata_announcement$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementMetadata_announcement">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementMetadata_announcement",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ItemMenu_node"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PinOption_node"
        }
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "announcer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pinned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUnpin",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canPin",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizationResult",
                  "kind": "LinkedField",
                  "name": "canCreateAnnouncement",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "SpaceAnnouncementsModule",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnouncementLink",
      "kind": "LinkedField",
      "name": "link",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "Node",
              "abstractKey": "__isNode"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastEditedAt",
      "storageKey": null
    }
  ],
  "type": "Announcement",
  "abstractKey": null
};
})();

(node as any).hash = "02faea5daa7c91e7972c163102673856";

export default node;
